export const DEFAULT_FORM_DATA = {
  is_active: true,
  name: '',
  service_days: '',
  count_days_from_delivered_at: false,
  product_variants: []
};

export const CONFIGURED_SKUS_TABLE_HEADERS = [
  { title: 'Product', lg: 6 },
  { title: 'SKU Id', lg: 3 },
  { title: 'Price', lg: 2 },
  { title: '', lg: 1 }
];

export const PRODUCTS_MODAL_TABLE_HEADERS = [
  { title: 'Product', lg: 8 },
  { title: 'SKU Id', lg: 2 },
  { title: 'Price', lg: 2 }
];
